import { Component, ChangeDetectionStrategy } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { UntypedFormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import {
  guestInvoiceNotificationMessages,
  userInvoiceNotificationMessages,
} from '@tv3/containers/automations/automations-wizard/invoice/messages'
import { Actions } from '@ngrx/effects'
import { distinctUntilChanged } from 'rxjs/operators'
import { untilDestroy } from '@tokeet-frontend/tv3-platform'
@Component({
  selector: 'app-invoice-automation-wizard',
  templateUrl: './invoice-automation-wizard.component.html',
  styleUrls: ['./invoice-automation-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InvoiceAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Invoice

  guestNotificationMessages = guestInvoiceNotificationMessages
  userNotificationMessages = userInvoiceNotificationMessages

  constructor(protected fb: UntypedFormBuilder, protected actions: Actions, protected store: Store<any>) {
    super(actions, store, fb)
    this.form.patchValue({ event: AutomationEventTypes.InvoiceCreated })
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.automation$
      .pipe(
        distinctUntilChanged((a, b) => a?.event === b?.event),
        untilDestroy(this)
      )
      .subscribe((automation) => {
        this.form.patchValue({
          days: automation?.settings?.days,
          hours: automation?.settings?.hours,
        })
      })
  }
}
